import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import StepButton from './StepButton';
import withWorkflow from './withWorkflow';

class StepNav extends Component {
  constructor(props) {
    super(props);
    this.confirm = this.confirm.bind(this);
  }

  confirm(e) {
    let disabled = e.target.parentNode.classList.contains('disabled');

    if (!disabled) {
      this.props.doConfirm(e);
    } else {
      e.preventDefault();
    }
  }

  render() {
    let notStartedStep = null;
    let stepButtons = null;

    if (this.props.gearOrder) {
      notStartedStep = this.props.gearOrder.workflow.steps.find(step => {
        return (
            step.id !== 15 && // Practitioner Confirmation (PRC)
            step.notStarted &&
            this.props.isStepValidForUser(this.props.gearOrder, step)
        );
      });

      stepButtons = this.props.gearOrder.workflow.steps.filter((step, index, workflowSteps) => {
        return (this.props.isStepValidForUser(this.props.gearOrder, step) && workflowSteps.findIndex(s => s.id === step.id) === index);
      }).map(step => {
        // hide the patient confirmation from practitioners, and the practitioner confirmation from patients
        if (this.props.isStepValidForUser(this.props.gearOrder, step)) {
          let stepMetaData = Object.values(this.props.workflowMetaData).find(metaStep => metaStep.id === step.id);
          return (
              <StepButton step={step}
                          steps={this.props.gearOrder.workflow.steps}
                          link={stepMetaData.route}
                          text={stepMetaData.breadcrumb}
                          orderId={this.props.gearOrder.id}
                          iconClassName={stepMetaData.iconClassName}
                          confirm={this.confirm}
                          notStartedStep={notStartedStep}
                          userType={this.props.userInfo.type}
                          key={step.id}
              />
          );
        } else {
          return null;
        }
      });
    }

    if (!this.props.gearOrder) {
      return null;
    }

    return (
        <div className="row display-flex">
          {(this.props.userInfo?.type !== 'prc') && (
              <div className="col-sm-1 col-xs-2 step-button">
                <div className="row">
                  <Link to="/order-history" onClick={this.props.doConfirm}>
                    <div className="btn-arrow btn-arrow-right">
                      <i className="fa fa-fw fa-history"></i>
                    </div>
                  </Link>
                </div>
                <div className="row step-text">
                  Order History
                </div>
              </div>
          )}
          {stepButtons}
        </div>
    );
  }
}

// wrap the component in the workflow HOC to get access to common workflow logic
export default withWorkflow(StepNav);
